import { render, staticRenderFns } from "./ProductApprovalAll.vue?vue&type=template&id=e78b9d78&scoped=true"
import script from "./ProductApprovalAll.vue?vue&type=script&lang=js"
export * from "./ProductApprovalAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78b9d78",
  null
  
)

export default component.exports